export const PAGES = {
    INTRO: 'intro',
    MANUAL: 'manual',
    FORM: 'form',
    ERROR: {
        DATA: 'error-data',
        BIRTH_DATE: 'error-birth-date',
        EXPIRATION: 'error-expiration-date',
        SUPPORT_NUMBER: 'error-support-number',
    },
    OTP: 'otp',
    ABANDONED: 'abandoned',
    SUCCESS: 'success',
    FAILED: 'failed',
    NO_SERVICE: 'no-service',
    STAND_BY: 'standby',
    NO_PHONE: 'no-phone',
    BAD_PHONE: 'bad-phone',
    DUPLICATED: 'duplicated',
    LOADING: 'loading',
    PHONE_NO_EXIST: 'phone_not_exist_otp'
}


export const StatusMap = {
    // form pages
    'created': PAGES.FORM, // este es solo de front
    'form': PAGES.FORM, // este es solo de front
    'terms_and_conditions': PAGES.FORM,
    'waiting_terms_and_conditions': PAGES.FORM,
    'prerequest': PAGES.FORM,
    'waiting_password': PAGES.FORM,

    // otp pages
    'waiting_otp_seguridad_social': PAGES.OTP,
    'waiting_login_seguridad_social': PAGES.OTP,
    'invalid_otp_seguridad_social': PAGES.OTP,

    //abandoned pages
    'abandoned_after_bad_phone': PAGES.ABANDONED,
    'abandoned_after_invalid_otp_seguridad_social': PAGES.ABANDONED,
    'abandoned_after_terms_and_conditions': PAGES.ABANDONED,
    'abandoned_after_waiting_otp_seguridad_social': PAGES.ABANDONED,

    //success pages
    'all_documents_downloaded': PAGES.SUCCESS,
    'partial_documents_downloaded': PAGES.SUCCESS,
    'consent_process_completed': PAGES.SUCCESS,
    'partial_documents_downloaded_and_deleted': PAGES.SUCCESS,
    'all_documents_downloaded_and_deleted': PAGES.SUCCESS,
    'failed_documents_downloaded': PAGES.SUCCESS,

    //failed pages
    'failed_with_retry': PAGES.FAILED,
    'failed_without_retry': PAGES.FAILED,
    'consent_process_canceled': PAGES.LOADING,

    //no-service pages
    'no_service': PAGES.NO_SERVICE,
    'no_sms_service': PAGES.NO_SERVICE,
    'no_clave_pin_service': PAGES.NO_SERVICE,
    //stand by pages
    'stand_by': PAGES.LOADING,

    //no phone pages
    'no-phone': PAGES.LOADING,
    'no_phone': PAGES.LOADING,
    'no-more-phone': PAGES.NO_PHONE,
    'no_more_phone': PAGES.NO_PHONE,

    //bad phone pages
    'bad_phone': PAGES.BAD_PHONE,

    //error pages
    'error_expiration_date': PAGES.ERROR.EXPIRATION,
    'error_birth_date': PAGES.ERROR.BIRTH_DATE,
    'error_support_number': PAGES.ERROR.SUPPORT_NUMBER,

    'duplicated': PAGES.DUPLICATED

}
